import React__default from 'react';
import distExports from '../../../_virtual/index2.js';
import { FontAwesomeIcon } from '../../../node_modules/@fortawesome/react-fontawesome/index.es.js';
import { faUser } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index.js';
import { COLORS } from '../../../helpers/constants.js';
import styles from './styles.module.scss.js';

/**
 * @description Nimvelo User Icon component
 * @props backgroundColor, color, pixelSize, userEmail
 */
const NvUserIcon = ({ backgroundColor = COLORS.PRIMARY, color = COLORS.WHITE, pixelSize, userEmail, }) => {
    const wrapperStyle = {
        width: `${pixelSize}px`,
        height: `${pixelSize}px`,
        fontSize: `${pixelSize * 0.55}px`,
        color,
        backgroundColor,
    };
    return (React__default.createElement("div", { className: styles.wrapper, style: wrapperStyle },
        React__default.createElement(FontAwesomeIcon, { icon: faUser, className: styles.icon }),
        React__default.createElement(distExports, { email: userEmail, className: styles.gravatar, size: pixelSize, default: "blank" })));
};
var component = React__default.memo(NvUserIcon);

export { NvUserIcon, component as default };
//# sourceMappingURL=component.js.map
